import { useMutation, useQueryClient } from '@tanstack/react-query'
import api, { withAuthenticatedHeaders } from '@/lib/api'
import { useAccessToken } from '@/features/auth/state/auth'

interface AddSignaturePayload {
  cpf: string
  assinatura: File
}

export function useAddSignatureUser() {
  const queryClient = useQueryClient()
  const token = useAccessToken()

  return useMutation({
    mutationFn: async ({ cpf, assinatura }: AddSignaturePayload) => {
      if (!token) throw new Error('Token de autenticação ausente.')
      if (!assinatura || assinatura.size === 0) throw new Error('Arquivo de assinatura inválido.')

      const formData = new FormData()
      formData.append('cpf', cpf || 'sem-cpf')
      formData.append('assinatura', assinatura)

      const response = await api.post('/signatures/user-assinatura/', formData, {
        headers: withAuthenticatedHeaders(token, {
          'Content-Type': 'multipart/form-data'
        })
      })

      if (!response.data) throw new Error('Resposta vazia ao adicionar assinatura.')
      queryClient.refetchQueries({
        queryKey: ['signature']
      })
      return response.data
    }
  })
}
